import { db } from '../config';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export interface SecuritySettings {
  sessionTimeouts: { [role: string]: number }; // in minutes, per role
  twoFactorEnabled: boolean;
  passcodeSettings: {
    length: number;
    requireNumbers: boolean;
    requireLetters: boolean;
    expireDays: number;
  };
}

export const getSecuritySettings = async (): Promise<SecuritySettings> => {
  const docRef = doc(db, 'settings', 'security');
  const docSnap = await getDoc(docRef);
  
  if (docSnap.exists()) {
    const data = docSnap.data() as any;
    // Backward compatibility: if sessionTimeout exists, convert to sessionTimeouts
    if (typeof data.sessionTimeout === 'number') {
      data.sessionTimeouts = { admin: data.sessionTimeout, staff: data.sessionTimeout };
      delete data.sessionTimeout;
    }
    return data as SecuritySettings;
  }
  
  // Return default settings if none exist
  return {
    sessionTimeouts: {
      admin: 120, // 2 hours
      staff: 60, // 1 hour
      customer: 30 // example
    },
    twoFactorEnabled: false,
    passcodeSettings: {
      length: 6,
      requireNumbers: true,
      requireLetters: false,
      expireDays: 30
    }
  };
};

export const updateSecuritySettings = async (settings: SecuritySettings): Promise<void> => {
  const docRef = doc(db, 'settings', 'security');
  await setDoc(docRef, settings);
}; 